import { createSlice } from "@reduxjs/toolkit"
import axios from "axios"

const initialState = {
  isAuthenticated: false,
  user: {},
  token: ""
}

const deliveryManagerAuthenticationSlice = createSlice({
  name: "deliveryManagerAuthentication",
  initialState,
  reducers: {
    handleDeliveryManagerLogin: (state, action) => {
      axios.defaults.headers.common["Authorization"] = `Bearer ${action.payload.token}`
      state.isAuthenticated = true
      state.user = action.payload
      state.token = action.payload.token
    },
    handleDeliveryManagerLogout: (state) => {
      state.isAuthenticated = false
      state.user = {}
      state.token = ""
    }
  }
})

export const { handleDeliveryManagerLogin, handleDeliveryManagerLogout } =
  deliveryManagerAuthenticationSlice.actions

export default deliveryManagerAuthenticationSlice.reducer
